import { ReminderModel } from "src/app/models/reminder";

export interface RemindersState
{
    models: ReminderModel[];
}

export const REMINDERS_FEATURE_KEY = 'reminders';